import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { GeoViewModel } from './models'

export const DevelopmentAreas = ({
  region: _region,
}: {
  region: GeoViewModel
}) => {
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '3.5rem'

  return (
    <Column gap={largerGap} alignItems="stretch">
      <h1>DevelopmentAreas</h1>
    </Column>
  )
}
